// Dashboard Users translations (pt-BR), loaded into dashboard.users by ./pt-BR.js
module.exports = {
  label: "Utilizadores",
  gender: {
    M: "Masculino",
    F: "Feminino",
    O: "Outro",
    N: "Não informado",
  },
  summary: require('./users/pt-BR.summary.js'),
  growth: require('./users/pt-BR.growth.js'),
  activity: require('./users/pt-BR.activity.js'),
  retention: require('./users/pt-BR.retention.js'),
  onboarding: require('./users/pt-BR.onboarding.js'),
  profile: require('./users/pt-BR.profile.js'),
  registration: require('./users/pt-BR.registration.js'),
  rankings: require('./users/pt-BR.rankings.js'),
};
